// @flow

import type {TasksState, Task, TaskType, State, Action} from '../types'
import {includes} from 'lodash'
// import {createSelector} from 'reselect'

const initialState: TasksState = {
  entities: [],
}

const tasks = (state: TasksState = initialState, action: Action) => {
  switch (action.type) {
    case 'SET_TASKS':
      return {
        ...state,
        entities: action.tasks,
      }
    default:
      return state
  }
}

// selectors
export const getTasks = (state: State) => state.tasks.entities

// TODO memoize this!
export const getTasksByType = (
  state: State,
  type: TaskType
): $ReadOnlyArray<Task> => state.tasks.entities.filter(t => t.type === type)

export const getTasksByTypes = (
  state: State,
  types: $ReadOnlyArray<TaskType>
): $ReadOnlyArray<Task> =>
  state.tasks.entities.filter(t => includes(types, t.type))

// helpers

export default tasks
